// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file entities/app/my_account/job_alerts.proto (package protos.entities.app.my_account, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file entities/app/my_account/job_alerts.proto.
 */
export const file_entities_app_my_account_job_alerts: GenFile = /*@__PURE__*/
  fileDesc("CihlbnRpdGllcy9hcHAvbXlfYWNjb3VudC9qb2JfYWxlcnRzLnByb3RvEh5wcm90b3MuZW50aXRpZXMuYXBwLm15X2FjY291bnQiIQoJSm9iQWxlcnRzEhQKDHNlbmRfYnlfcHVzaBgBIAEoCGIGcHJvdG8z");

/**
 * @generated from message protos.entities.app.my_account.JobAlerts
 */
export type JobAlerts = Message<"protos.entities.app.my_account.JobAlerts"> & {
  /**
   * @generated from field: bool send_by_push = 1;
   */
  sendByPush: boolean;
};

/**
 * Describes the message protos.entities.app.my_account.JobAlerts.
 * Use `create(JobAlertsSchema)` to create a new message.
 */
export const JobAlertsSchema: GenMessage<JobAlerts> = /*@__PURE__*/
  messageDesc(file_entities_app_my_account_job_alerts, 0);

